import Leveraged from "../Components/Leveraged.jsx";
import Book from "../Components/Book.jsx";
import Smart from "../Components/Smart.jsx";
import Poly from "../Components/Poly.jsx";
import Power from "../Components/Power.jsx";
import './styles/About.scss';


function About() {


    return (
    <main>
        <Leveraged />
        <Book />
        <Smart />
        <Poly />
        <Power />
    </main>
    )
}

export default About;